import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-tizo',
  templateUrl: './work-tizo.component.html',
  styleUrls: ['./work-tizo.component.scss']
})

export class WorkTizoComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

  //Image 100% width container
  imgContainerAlt = 'Tizo Image';
  imgContainerUrl = 'assets/img/tizo/tizo-img-container1.jpg';

  //Project overview devices
  projectImgDevices = 'assets/img/tizo/tizo_devices.png';
  altImgDevicesTitle = 'Tizo Devices'
}




// WEBPACK FOOTER //
// ./src/app/work-tizo/work-tizo.component.ts